import { prop } from 'ramda';

const toSkillsetNames = (skillsets: { name: string }[]) => skillsets.map(prop('name')).join(', ');

export { toSkillsetNames };
